<template>
  <div class="content">
    <div class="sidebar-box">
      <aside>
        <a href="#home" class="smooth-scroll active"><i class="fa-solid fa-home"></i>Home</a>
        <a href="#about" class="smooth-scroll "><i class="fa-solid fa-user-tie"></i>About ME</a>
        <a href="#services" class="smooth-scroll "><i class="fa-solid fa-gears"></i>Services</a>
        <a href="#resume" class="smooth-scroll "><i class="fa-solid fa-chart-column"></i>Resume</a>
        <a href="#portfolio" class="smooth-scroll "><i class="fa-solid fa-code"></i>Portfolio</a>
        <a href="#contact" class="smooth-scroll "><i class="fa-solid fa-phone"></i>Contact</a>
      </aside>
    </div>
    <div class="home">
      <VueGlobeClone/>
      <VueAboutME/>
      <VueServices/>
      <VueResume/>
      <PortfolioApp/>
      <VueContact/>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import VueGlobeClone from "@/components/VueGlobeClone";
import VueAboutME from "@/components/VueAboutME";
import VueServices from "@/components/VueServices";
import VueResume from "@/components/VueResume";
import PortfolioApp from "@/components/PortfolioApp";
import VueContact from "@/components/VueContact";

export default {
  name: 'HomeView',
  components: {
    VueContact,
    PortfolioApp,
    VueResume,
    VueServices,
    VueAboutME,
    VueGlobeClone,
  },
  mounted() {
    $(window).scroll(function () {
      var scrollDistance = $(window).scrollTop() + 200;

      // Assign active class to nav links while scolling
      $('.section').each(function (i) {
        if ($(this).position().top <= scrollDistance) {
          $('.smooth-scroll.active').removeClass('active');
          $('.smooth-scroll').eq(i).addClass('active');
        }
      });
    }).scroll();


    $('.smooth-scroll').on('click', function () {
      var sectionTo = $(this).attr('href');
      $('.smooth-scroll.active').removeClass('active');
      $('html, body').stop().animate({
        scrollTop: $(sectionTo).offset().top - 50
      }, 300);
    });


  }

}
</script>

<style scoped>
.content {
  display: flex;
  width: 100%;
  align-items: stretch;
}

.sidebar-box {
  width: 80px;
}

aside {
  background-color: rgba(6, 9, 43, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 25px;
  height: max-content;
  width: 70px;
  position: fixed;
  top: 50%;
  left: 5px;
  z-index: 900;
  transform: translateY(-50%);
  box-shadow: 0 0 4px rgba(255, 255, 255, 0.3), 0 0 6px rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  padding: 20px 3px;
  transition: all linear 0.3s 0.01s;
}

aside:hover {
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.6), 0 0 10px rgba(255, 255, 255, 0.3);
  transition: all linear 0.3s 0.01s;
}

aside a {
  color: var(--font-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  transition: all linear 0.3s 0.01s;
}

aside a:hover,
aside a.active {
  color: var(--primary-color);
  transition: all linear 0.3s 0.01s;
}

aside a i {
  font-size: 36px;
}

.home {
  width: -webkit-fill-available;
  padding: 0 10px;
}

@media (max-width: 991px) {
  .sidebar-box {
    width: 100%;
    height: 80px;
  }

  .content {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .home {
    height: -webkit-fill-available;
    width: 100%;
    padding: 0 10px;
  }

  aside {
    background-color: rgba(6, 9, 43, 0.5);
    backdrop-filter: blur(10px);
    border-radius: 25px;
    width: calc(100vw - 10px);
    height: 70px;
    position: fixed;
    top: 5px;
    left: 5px;
    z-index: 900;
    transform: translateY(0);
    box-shadow: 0 0 4px rgba(255, 255, 255, 0.3), 0 0 6px rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    gap: 10px;
    padding: 20px 3px;
    transition: all linear 0.3s 0.01s;
  }

  aside a:hover {
    color: var(--font-color);
    transition: all linear 0.3s 0.01s;
  }

  aside a.active {
    color: var(--primary-color);
    transition: all linear 0.3s 0.01s;
  }
}

@media (max-width: 512px) {
  aside a {
    font-size: 12px;
  }

  aside a i {
    font-size: 16px;
  }
}
</style>